import { useRootStore } from "@/stores/root"
import { useMonitoring } from "@/use/useMonitoring"

export function setupResponseInterceptors(axiosInstance) {
  const bp_monitoring = useMonitoring()

  // Response interceptor to ensure loading state is cleared
  axiosInstance.interceptors.response.use(
    (response) => {
      const rootStore = useRootStore()
      setTimeout(() => {
        rootStore.stopLoading()
      }, 100) // let us see the progress bar for a little longer

      const method = (response.config?.method || "").toLowerCase()
      if (["post", "put", "delete"].includes(method) && response.config?.requestId) {
        if (bp_monitoring.captureDiagnostics()) {
          console.log(`[HTTP][${response.config.requestId}] ${method.toUpperCase()} request succeeded`, {
            url: response.config.url,
            method,
            status: response.status,
          })
        }
      }

      return response
    },
    (error) => {
      const rootStore = useRootStore()
      rootStore.stopLoading()

      return Promise.reject(error)
    }
  )

  return axiosInstance
}
